import React, { Component } from "react";
import { Tooltip } from "reactstrap";

export default class JedaiTooltip extends Component {
    constructor(props) {
        super(props);

        this.target = React.createRef();
        this.state = { isOpen: false };
        this.toggle = this.toggle.bind(this);
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
        let props = { ...this.props, className: undefined };
        return (
            <React.Fragment>
                <span className={this.props.className} ref={this.target}>
                    {this.props.children}
                </span>

                {this.target.current && (
                    <Tooltip isOpen={this.state.isOpen} toggle={this.toggle} target={this.target.current} {...props}>
                        {this.props.message}
                    </Tooltip>
                )}
            </React.Fragment>
        );
    }
}
